<template>
  <div class="c-credit-card c-page payment-form">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--6">
        <h1 class="f-headline">
          Her er dine
          <strong>kvitteringer</strong>
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <ul class="c-home__campaigns">
          <li
            v-for="(reciept, index) in reciepts"
            :key="'newsletter_' + reciept.id"
            class="c-home__reciept"
          >
            <div class="reciept">
              <div class="reciept-data">
                <div
                  v-if="reciept.paid"
                  class="reciept-status f-small f-strong"
                >
                  Betalt -
                  {{ new Date(reciept.date * 1000) | dateFormat("D/M YYYY") }}
                </div>
                <div
                  v-if="!reciept.paid"
                  class="reciept-status f-small f-strong"
                >
                  Ubetalt -
                  {{ new Date(reciept.date * 1000) | dateFormat("D/M YYYY") }}
                </div>
                <div class="attribute-value">
                  DKK {{ reciept.amount_due / 100 }}
                </div>
              </div>
              <a
                v-if="reciept.paid && !reciept.sent"
                class="send-receipt"
                href
                @click.once.prevent="sendReciept(index)"
                >Send pr. mail</a
              >
              <span v-if="reciept.paid && reciept.sent" class="send-receipt">{{
                reciept.sendText
              }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reciepts",
  data() {
    return {
      user: this.$route.meta.user,
      reciepts: [],
    };
  },
  mounted: function() {
    this.$userService.refreshLocalUser().then((user) => {
      console.log("fetched user");

      this.$userService.getInvoices().then((response) => {
        console.log("data");
        console.log(response);

        this.reciepts = response.data.data;
        console.log(this.reciepts);
      });
    });
  },

  methods: {
    sendReciept(index) {
      console.log("INDEX: " + index);

      const invoiceId = this.reciepts[index].id;

      this.$userService.sendReciept(invoiceId).then((response) => {
        console.log("response");
        console.log(response);
        const reciept = this.reciepts[index];
        reciept.sent = true;
        reciept.sendText = "Sender mail";

        this.$set(this.reciepts, index, reciept);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.reciept {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.c-home__reciept {
  margin-bottom: 10px;
}
</style>
